// Auto generated file, do not manually modify!
// com.hotpads.customermanagement.client.eventtracking.enums.EnterprisePageFeature

export enum EnterprisePageFeature {
  ANALYTICS_ADSPEND = 'ANALYTICS_ADSPEND',
  ANALYTICS_FUNNEL = 'ANALYTICS_FUNNEL',
  ANALYTICS_MARKET_INSIGHTS = 'ANALYTICS_MARKET_INSIGHTS',
  ANALYTICS_OVERVIEW = 'ANALYTICS_OVERVIEW',
  ANALYTICS_RENT_COMPS = 'ANALYTICS_RENT_COMPS',
  BILLING_DUE = 'BILLING_DUE',
  BILLING_PAID = 'BILLING_PAID',
  BILLING_SETTINGS = 'BILLING_SETTINGS',
  CLAIM_PROPERTIES = 'CLAIM_PROPERTIES',
  MY_PROPERTIES = 'MY_PROPERTIES',
  MY_PROPERTIES_AT_RISK = 'MY_PROPERTIES_AT_RISK',
  MY_PROPERTIES_BONUS = 'MY_PROPERTIES_BONUS',
  MY_PROPERTIES_CLAIMED = 'MY_PROPERTIES_CLAIMED',
  MY_PROPERTIES_FOR_RENT = 'MY_PROPERTIES_FOR_RENT',
  MY_PROPERTIES_OFF_MARKET = 'MY_PROPERTIES_OFF_MARKET',
  PROPERTY_EDIT = 'PROPERTY_EDIT',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
}

export const EnterprisePageFeature_values = [
  EnterprisePageFeature.ANALYTICS_ADSPEND,
  EnterprisePageFeature.ANALYTICS_FUNNEL,
  EnterprisePageFeature.ANALYTICS_MARKET_INSIGHTS,
  EnterprisePageFeature.ANALYTICS_OVERVIEW,
  EnterprisePageFeature.ANALYTICS_RENT_COMPS,
  EnterprisePageFeature.BILLING_DUE,
  EnterprisePageFeature.BILLING_PAID,
  EnterprisePageFeature.BILLING_SETTINGS,
  EnterprisePageFeature.CLAIM_PROPERTIES,
  EnterprisePageFeature.MY_PROPERTIES,
  EnterprisePageFeature.MY_PROPERTIES_AT_RISK,
  EnterprisePageFeature.MY_PROPERTIES_BONUS,
  EnterprisePageFeature.MY_PROPERTIES_CLAIMED,
  EnterprisePageFeature.MY_PROPERTIES_FOR_RENT,
  EnterprisePageFeature.MY_PROPERTIES_OFF_MARKET,
  EnterprisePageFeature.PROPERTY_EDIT,
  EnterprisePageFeature.USER_MANAGEMENT,
] as const;
